import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { RequirementListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialRequirementList } from '../../logics/requirements/createInitialRequirementList';

/**
 * 募集・採用情報に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useRequirements = (args: HooksArgument) => {
  const [requirementList, setRequirementList] = useState<RequirementListType[]>(
    createInitialRequirementList(args)
  );

  const selectedRequirementList = useMemo(() => {
    return requirementList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [requirementList]);

  // チェック状態更新処理
  const updateIsCheckedRequirementList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = requirementList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setRequirementList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [requirementList]
  );

  // 求人件数更新処理
  const updateRequirementListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setRequirementList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    requirementList,
    selectedRequirementList,
    updateIsCheckedRequirementList,
    updateRequirementListJobCount,
  };
};
